import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion";
import { useGame } from "../GameState";
import { setMuted, isMuted } from "../sfx";

const HUD = ({ level, levelLabel, lives, combo, timer }) => {
  const { state } = useGame();
  const [, force] = useState(0);
  const muted = isMuted();
  const toggleMute = () => { setMuted(!muted); force((x) => x + 1); };

  return (
    <div className="md-hud">
      <div className="md-hud-left">
        {level && <span className="md-hud-pill md-hud-level">L{level} · {levelLabel}</span>}
        <span className="md-hud-pill md-hud-score">★ {state.totalScore}</span>
        {state.bestScore > 0 && (
          <span className="md-hud-pill md-hud-best">best {state.bestScore}</span>
        )}
      </div>
      <div className="md-hud-right">
        {timer !== undefined && timer !== null && (
          <span className={`md-hud-pill md-hud-timer ${timer <= 10 ? "md-low" : ""}`}>⏱ {timer}s</span>
        )}
        {combo && combo > 1 && (
          <motion.span
            key={combo}
            className="md-hud-pill md-hud-combo"
            initial={{ scale: 1.4 }}
            animate={{ scale: 1 }}
          >
            ×{combo}
          </motion.span>
        )}
        {lives !== undefined && lives !== null && (
          <span className="md-hud-pill md-hud-lives">
            {Array.from({ length: 3 }).map((_, i) => (
              <span key={i} className={`md-life ${i < lives ? "md-on" : "md-off"}`}>♥</span>
            ))}
          </span>
        )}
        <button className="md-hud-pill md-hud-mute" onClick={toggleMute} aria-label="toggle sound">
          {muted ? "🔇" : "🔊"}
        </button>
      </div>
    </div>
  );
};

export const AchievementPopup = () => {
  const { state, clearPopup } = useGame();
  const popup = state.popup;

  return (
    <AnimatePresence>
      {popup && (
        <motion.div
          key={popup.ts}
          className={`md-popup md-popup-${popup.kind || "info"}`}
          initial={{ y: -50, opacity: 0, scale: 0.9 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: -30, opacity: 0 }}
          transition={{ type: "spring", stiffness: 220, damping: 18 }}
          onAnimationComplete={() => {
            setTimeout(clearPopup, 2400);
          }}
        >
          <div className="md-popup-icon">
            {popup.kind === "achievement" ? "🏆" : popup.kind === "level" ? "✨" : "❤"}
          </div>
          <div className="md-popup-text">
            <div className="md-popup-title">{popup.title}</div>
            {popup.sub && <div className="md-popup-sub">{popup.sub}</div>}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default HUD;
